var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message",class:{ show: _vm.visible }},[_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/images/common/message-info@2x.png")}}),_c('span',{staticClass:"content"},[_vm._v(_vm._s(_vm.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }